import { render } from "./RenewConfirmed.vue?vue&type=template&id=5c0c70ac"
import script from "./RenewConfirmed.vue?vue&type=script&lang=js"
export * from "./RenewConfirmed.vue?vue&type=script&lang=js"

import "./RenewConfirmed.vue?vue&type=style&index=0&id=5c0c70ac&lang=scss"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__